module.exports = __webpack_public_path__ + "img/img_19.1fb28aac.jpg";